import React from 'react'
import { useParams } from 'react-router-dom'
import useFetcherDataProvinces from '../hooks/useFetcherDataProvinces'
import Loader from 'react-loader-spinner'
import formatNumber from '../helpers/formatNumber'
import { Link } from 'react-router-dom'

const ProvinceDetail = () => {
  const { province } = useParams()
  const [dataProvinces, dataProvincesLoading] = useFetcherDataProvinces()
  console.log(province)
  if (dataProvincesLoading) {
    return <Loader
    type="ThreeDots"
    color="#00BFFF"
    height={500}
    width={500}
    className="text-center"
    />
  }
  return (
    <>      
      {dataProvinces.filter(el => el.provinsi === province).map(province => (
        <div className="container text-center">
          <h1 className="mt-3">Jumlah Kasus di Provinsi {province.provinsi}</h1>
          <div className="row my-4">
            <div className="col-3">
            <div className="card rounded shadow">
              <div className="card-body text-primary" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(province.kasusPosi)}</h1></div>
              <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Terkonfirmasi</strong></div>
            </div>
            </div>
            <div className="col-3">
            <div className="card rounded shadow">
              <div className="card-body text-warning" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(province.kasusPosi - province.kasusSemb - province.kasusMeni)}</h1></div>
              <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Dalam Perawatan</strong></div>
            </div>
            </div>
            <div className="col-3">
            <div className="card rounded shadow">
              <div className="card-body text-success" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(province.kasusSemb)}</h1></div>
              <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Sembuh</strong></div>
            </div>
            </div>
            <div className="col-3">
            <div className="card rounded shadow">
              <div className="card-body text-danger" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(province.kasusMeni)}</h1></div>
              <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Meninggal</strong></div>
            </div>
            </div>
          </div>
          <Link to="/provinces" className="btn btn-info mt-5">Back to Provinces</Link>
        </div>
      ))}
    </>
  )
}

export default ProvinceDetail